"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtension = exports.setMimeType = exports.correctFileType = void 0;

var _constants = require("../constants");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var correctFileType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var fileExtension;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!file.type.includes('svg')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", setMimeType(_constants.MIME_TYPES.svg, file));

          case 2:
            fileExtension = getFileExtension(file.name);

            if (fileExtension) {
              _context.next = 5;
              break;
            }

            throw new Error(_constants.ERROR_MESSAGES.fileNoExtension);

          case 5:
            if (!(fileExtension === 'glb')) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", setMimeType(_constants.MIME_TYPES.glb, file));

          case 7:
            if (!(fileExtension === 'gltf')) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", setMimeType(_constants.MIME_TYPES.gltf, file));

          case 9:
            return _context.abrupt("return", file);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function correctFileType(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.correctFileType = correctFileType;

var setMimeType = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, file) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = File;
            _context2.t1 = Blob;
            _context2.next = 4;
            return file.arrayBuffer();

          case 4:
            _context2.t2 = _context2.sent;
            _context2.t3 = [_context2.t2];
            _context2.t4 = new _context2.t1(_context2.t3);
            _context2.t5 = [_context2.t4];
            _context2.t6 = file.name;
            _context2.t7 = {
              type: type
            };
            return _context2.abrupt("return", new _context2.t0(_context2.t5, _context2.t6, _context2.t7));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function setMimeType(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.setMimeType = setMimeType;

var getFileExtension = function getFileExtension(fileName) {
  return fileName.slice((Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1);
};

exports.getFileExtension = getFileExtension;